import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "span-2 mr-20" }
const _hoisted_2 = { class: "span-2" }
const _hoisted_3 = {
  key: 2,
  class: "row"
}
const _hoisted_4 = { class: "span-2 mr-20" }
const _hoisted_5 = { class: "span-2" }

import { computed, watch } from 'vue';
import { _CREATE } from '@shell/config/query-params';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import LabeledInput from '@components/Form/LabeledInput/LabeledInput.vue';
import { INGRESS_DUAL, TRAEFIK, INGRESS_NGINX } from '@shell/edit/provisioning.cattle.io.cluster/shared';
import Checkbox from '@components/Form/Checkbox/Checkbox.vue';
import formRulesGenerator from '@shell/utils/validators/formRules';

interface Props {
  mode?: string;
  ingressSelection: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'IngressConfiguration',
  props: /*@__PURE__*/_mergeModels({
    mode: { default: () => (_CREATE) },
    ingressSelection: {}
  }, {
    "compatibilityMode": { type: Boolean },
    "compatibilityModeModifiers": {},
    "nginxHttp": {},
    "nginxHttpModifiers": {},
    "nginxHttps": {},
    "nginxHttpsModifiers": {},
    "traefikHttp": {},
    "traefikHttpModifiers": {},
    "traefikHttps": {},
    "traefikHttpsModifiers": {},
  }),
  emits: /*@__PURE__*/_mergeModels(['validation-changed'], ["update:compatibilityMode", "update:nginxHttp", "update:nginxHttps", "update:traefikHttp", "update:traefikHttps"]),
  setup(__props: any, { emit: __emit }) {


const store = useStore();
const { t } = useI18n(store);

const emit = __emit;

const compatibilityMode = _useModel<boolean>(__props, 'compatibilityMode');
const nginxHttp = _useModel<number>(__props, 'nginxHttp');
const nginxHttps = _useModel<number>(__props, 'nginxHttps');
const traefikHttp = _useModel<number>(__props, 'traefikHttp');
const traefikHttps = _useModel<number>(__props, 'traefikHttps');

const nginxHttpRules = computed(() => {
  const { portNumber, isInteger } = formRulesGenerator(t, { key: t('cluster.ingress.configurationOptions.nginx.http') });
  const portRules = [(val: any) => !val ? undefined : isInteger(val), portNumber];

  return [...portRules,
    (val: any) => {
      if (__props.ingressSelection === INGRESS_DUAL && String(val) === String(traefikHttp.value)) {
        return t('cluster.ingress.validation.portsMatch');
      }

      return undefined;
    }
  ];
});

const nginxHttpsRules = computed(() => {
  const { portNumber, isInteger } = formRulesGenerator(t, { key: t('cluster.ingress.configurationOptions.nginx.https') });
  const portRules = [(val: any) => !val ? undefined : isInteger(val), portNumber];

  return [...portRules,
    (val: any) => {
      if (__props.ingressSelection === INGRESS_DUAL && String(val) === String(traefikHttps.value)) {
        return t('cluster.ingress.validation.portsMatch');
      }

      return undefined;
    }
  ];
});

const traefikHttpRules = computed(() => {
  const { portNumber, isInteger } = formRulesGenerator(t, { key: t('cluster.ingress.configurationOptions.traefik.http') });
  const portRules = [(val: any) => !val ? undefined : isInteger(val), portNumber];

  return [...portRules, (val: any) => {
    if (__props.ingressSelection === INGRESS_DUAL && String(val) === String(nginxHttp.value)) {
      return t('cluster.ingress.validation.portsMatch');
    }

    return undefined;
  }
  ];
});

const traefikHttpsRules = computed(() => {
  const { portNumber, isInteger } = formRulesGenerator(t, { key: t('cluster.ingress.configurationOptions.traefik.https') });
  const portRules = [(val: any) => !val ? undefined : isInteger(val), portNumber];

  return [...portRules, (val: any) => {
    if (__props.ingressSelection === INGRESS_DUAL && String(val) === String(nginxHttps.value)) {
      return t('cluster.ingress.validation.portsMatch');
    }

    return undefined;
  }
  ];
});

const isValid = computed(() => {
  const check = (val: any, rules: any[]) => rules.every((rule) => rule(val) === undefined);

  if (__props.ingressSelection === INGRESS_DUAL) {
    return check(nginxHttp.value, nginxHttpRules.value) && check(nginxHttps.value, nginxHttpsRules.value) &&
      check(traefikHttp.value, traefikHttpRules.value) && check(traefikHttps.value, traefikHttpsRules.value);
  }
  if (__props.ingressSelection === TRAEFIK) {
    return check(traefikHttp.value, traefikHttpRules.value) && check(traefikHttps.value, traefikHttpsRules.value);
  }
  if (__props.ingressSelection === INGRESS_NGINX) {
    return check(nginxHttp.value, nginxHttpRules.value) && check(nginxHttps.value, nginxHttpsRules.value);
  }

  return true;
});

watch(isValid, (val) => emit('validation-changed', val), { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h4", null, _toDisplayString(_unref(t)('cluster.ingress.configurationOptions.title')), 1),
    _cache[7] || (_cache[7] = _createTextVNode()),
    (_ctx.ingressSelection === _unref(INGRESS_DUAL))
      ? (_openBlock(), _createBlock(Checkbox, {
          key: 0,
          value: compatibilityMode.value,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((compatibilityMode).value = $event)),
          mode: _ctx.mode,
          "label-key": "cluster.ingress.configurationOptions.compatibilityMode",
          class: "mb-10"
        }, null, 8, ["value", "mode"]))
      : _createCommentVNode("", true),
    _cache[8] || (_cache[8] = _createTextVNode()),
    (_ctx.ingressSelection === _unref(TRAEFIK) || _ctx.ingressSelection === _unref(INGRESS_DUAL))
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["row", _ctx.ingressSelection === _unref(INGRESS_DUAL) ? 'mb-10' : ''])
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(LabeledInput, {
              value: traefikHttp.value,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((traefikHttp).value = $event)),
              "label-key": "cluster.ingress.configurationOptions.traefik.http",
              mode: _ctx.mode,
              rules: traefikHttpRules.value
            }, null, 8, ["value", "mode", "rules"])
          ]),
          _cache[5] || (_cache[5] = _createTextVNode()),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(LabeledInput, {
              value: traefikHttps.value,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((traefikHttps).value = $event)),
              "label-key": "cluster.ingress.configurationOptions.traefik.https",
              mode: _ctx.mode,
              rules: traefikHttpsRules.value
            }, null, 8, ["value", "mode", "rules"])
          ])
        ], 2))
      : _createCommentVNode("", true),
    _cache[9] || (_cache[9] = _createTextVNode()),
    (_ctx.ingressSelection === _unref(INGRESS_NGINX) || _ctx.ingressSelection === _unref(INGRESS_DUAL))
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(LabeledInput, {
              value: nginxHttp.value,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((nginxHttp).value = $event)),
              "label-key": "cluster.ingress.configurationOptions.nginx.http",
              mode: _ctx.mode,
              rules: nginxHttpRules.value
            }, null, 8, ["value", "mode", "rules"])
          ]),
          _cache[6] || (_cache[6] = _createTextVNode()),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(LabeledInput, {
              value: nginxHttps.value,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((nginxHttps).value = $event)),
              "label-key": "cluster.ingress.configurationOptions.nginx.https",
              mode: _ctx.mode,
              rules: nginxHttpsRules.value
            }, null, 8, ["value", "mode", "rules"])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})